module.exports = __webpack_public_path__ + "img/TECNOLOGIA-BALENO-2.c974a58a.jpg";